import { ajaxT } from 'util'
import axios from 'axios'

/**
 * 获取收藏夹记录
 */
export function favoritesList(params) {
  return ajaxT.post('tool/favoritesList', params)
}
